import { ColorEnum } from "./ColorEnums";

export enum WarningType {
    WARNING = 1,
    URGENT = 2,
    FINAL_NOTICE = 3,
}

export const WarningTypeText = {
    [WarningType.WARNING]: {
        id: WarningType.WARNING,
        color: ColorEnum.YELLOW,
        title: "Warning"
    },
    [WarningType.URGENT]: {
        id: WarningType.URGENT,
        color: ColorEnum.RED,
        title: "Urgent"
    },
    [WarningType.FINAL_NOTICE]: {
        id: WarningType.FINAL_NOTICE,
        color: ColorEnum.RED,
        title: "Final Notice"
    },
}